import type { ActorId } from "./queries";

interface ActorDatabaseProps {
	actorId: ActorId;
}

export function ActorDatabase(_props: ActorDatabaseProps) {
	return null;
}
